import { render, staticRenderFns } from "./BlogCard2.vue?vue&type=template&id=54d705c6&scoped=true&"
import script from "./BlogCard2.vue?vue&type=script&lang=js&"
export * from "./BlogCard2.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard2.vue?vue&type=style&index=0&id=54d705c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d705c6",
  null
  
)

export default component.exports